var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 38,
    viewBox: "0 0 43 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5068 1.91965C19.8764 -0.288321 23.1235 -0.288321 24.4931 1.91965L24.4969 1.92582L42.2592              32.5084C43.6302 34.8886 41.9071 37.7713 39.1843 37.7713H3.66889C1.07181 37.7713 -0.619779 34.8704                        0.740744 32.5084L0.741642 32.5068L18.503 1.92582L18.5068 1.91965ZM19.3602 2.44091L1.60728                        33.0075C1.60714 33.0077 1.60741 33.0072 1.60728 33.0075C0.620432 34.7219 1.86349 36.7713                        3.66889 36.7713H39.1843C41.1573 36.7713 42.3694 34.7045 41.393 33.0082C41.3929 33.008 41.3932                        33.0085 41.393 33.0082L23.6396 2.44087C22.6602 0.871258 20.3396 0.871272 19.3602 2.44091Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 30.8468V27.4981H23.1882V30.8468H19.666ZM22.6012 25.6054H20.5466L20.1063              18.0345V13.3755H23.1882V17.8889L22.6012 25.6054Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.5910421e450ca44cfcb490ad3d430dc5.svg";
export { ForwardRef as ReactComponent };